module.exports = __webpack_public_path__ + "static/Collaboration-383aa1516a104febb5f72aa77f39869e.png";